// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

const MuiCssBaseline = {
  "@global": {
    iframe: {
      border: 0,
    },
  },
};

export default MuiCssBaseline;
